import { render, staticRenderFns } from "./prorecord.vue?vue&type=template&id=0e8bb707&scoped=true&"
import script from "./prorecord.vue?vue&type=script&lang=js&"
export * from "./prorecord.vue?vue&type=script&lang=js&"
import style0 from "./prorecord.vue?vue&type=style&index=0&id=0e8bb707&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8bb707",
  null
  
)

export default component.exports